import { BaseTesto } from '@lucan/base-ui'

export default function Sottotitolo(props) {
  const { children, grigio, ...rest } = props

  return (
    <BaseTesto
      variant='body2'
      {...(grigio && { color: 'text.secondary' })}
      {...rest}
    >
      {children}
    </BaseTesto>
  )
}
